const $secondaryContent = $('.tk-header, .tk-footer, #menu, #donate-main-header');
const $main = $('#donate-main');
let $primaryContent = $('#donation-form-container');
if (!$primaryContent.length) {
  $primaryContent = $main;
}

const sizePage = () => {
  let h = 0;
  $secondaryContent.filter(':visible').each(function () {
    h += $(this).outerHeight(true);
  });
  h += ($main.outerHeight(true) - $main.outerHeight());
  $primaryContent.css('min-height', `calc(100vh - ${h}px)`);
};
sizePage();
$(window).resize(sizePage);
